import type { Size } from '@/core/geometry/framing';
import type { Placement } from '@/core/project/placement';
import { cn } from '@/lib/cn';
import { AspectGlyph } from './primitives';
import { usePlacementText } from './use-placement-text';

/** What a place asks of a video, as quiet tiles: the shape (drawn), the length, the largest file. */
export function PlacementFacts({ placement, source, className }: { readonly placement: Placement; readonly source?: Size; readonly className?: string }) {
  const text = usePlacementText();
  return (
    <ul aria-label={text.name(placement)} className={cn('flex flex-wrap gap-1.5', className)}>
      {text.facts(placement, source).map((fact) => (
        <li key={fact.key} className="inline-flex h-8 items-center gap-1 rounded-lg bg-elevated px-2.5 text-[13px] font-medium text-fg tabular ring-1 ring-line ring-inset">
          {fact.aspect && <AspectGlyph aspect={fact.aspect} max={12} className="-ml-1 text-fg-muted" />}
          {fact.text}
        </li>
      ))}
    </ul>
  );
}
